import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import SubscriptionsTable from "@/components/subscriptions/subscriptions-table/subscriptions-data-table";

const subscriptionsSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
});

export const Route = createFileRoute("/_super/super/subscriptions")({
  validateSearch: subscriptionsSearchSchema,
  component: SubscriptionsPage,
});

function SubscriptionsPage() {
  const searchParams = Route.useSearch();

  return (
    <SubscriptionsTable
      currentPage={searchParams.page}
      basePath="/super/subscriptions"
      searchParams={searchParams}
    />
  );
}
